// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"f756f637","115":"c705c1b5","118":"93faccb0","231":"88202260","307":"73b50992","331":"b1d94499","342":"4c939707","366":"18f7aabc","453":"f3318e4f","537":"05658928","580":"af865b5f","722":"59a8512a","773":"ab703e39","818":"2ee84f6e","987":"2cbe0c99"}[chunkId] + ".chunk.js";
};